import { render } from "./GridDrepturiCustomsiMeniu.vue?vue&type=template&id=1ba6802d&scoped=true"
import script from "./GridDrepturiCustomsiMeniu.vue?vue&type=script&lang=js"
export * from "./GridDrepturiCustomsiMeniu.vue?vue&type=script&lang=js"

import "./GridDrepturiCustomsiMeniu.vue?vue&type=style&index=0&id=1ba6802d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ba6802d"]])

export default __exports__